'use client';

import { useEffect, useState } from 'react';
import { ServiceForm } from '@/components/admin/services/ServiceForm';
import { getServiceCategories } from '@/lib/actions/service-categories';
import { getInsights } from '@/lib/actions/insights';

export default function AdminServiceNewPage() {
  const [categories, setCategories] = useState<Awaited<ReturnType<typeof getServiceCategories>>>([]);
  const [insights, setInsights] = useState<Awaited<ReturnType<typeof getInsights>>>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getServiceCategories(), getInsights()]).then(([categoriesData, insightsData]) => {
      setCategories(categoriesData);
      setInsights(insightsData);
      setLoading(false);
    });
  }, []);

  if (loading) {
    return null;
  }

  return <ServiceForm categories={categories} allInsights={insights} />;
}
